import {z} from '@hono/zod-openapi';

export const addServiceCampaignRequestSchema = z
  .object({
    serviceCampaign: z.object({
      platformCode: z.string().min(1).max(100).openapi({example: 'HONDA'}),
      serviceCode: z.string().min(1).max(100).openapi({example: '297'}),
      serviceCampaignId: z.string().min(1).max(100).openapi({example: '297'}),
    }),
  })
  .openapi('AddServiceCampaignRequest');
export type AddServiceCampaignRequest = z.infer<typeof addServiceCampaignRequestSchema>;
